/**
 * The single line a rider ends up with in the field once they pick a row.
 *
 * Mapbox Search Box results carry the place's name and its address separately,
 * and `full_address` is NOT reliably name-first: it came back as
 * "Philadelphia, Pennsylvania 19104, United States" for 30th Street Station and
 * "1136 Arch Street, Philadelphia…" for Reading Terminal Market. Taking it
 * verbatim meant clicking a row *titled* "30th Street Station" put a postcode
 * in the pickup field, and the rider went on to request a ride to a ZIP code.
 *
 * The name is the part they recognised and clicked, so it leads unless the
 * address already carries it.
 *
 * `supabase/functions/location/index.ts` composes the same way at the source.
 * This is the defensive restatement one layer down: it also covers the v5
 * geocoder fallback, and it means the fix does not depend on the deployed
 * function version.
 */
export function withPlaceNameLeading(name: string, placeName: string): string {
  const label = name.trim();
  const context = placeName.trim();
  if (!label) return context;
  if (!context) return label;
  // Already name-first (the common case) — do not repeat it.
  if (context.toLowerCase().startsWith(label.toLowerCase())) return context;
  return `${label}, ${context}`;
}
